import { FormBaseTableComponent } from '../form-base-table/form-base-table.component';
import { Component } from '@angular/core';
import { msseKeys } from '@libs/shared/form-helpers/forms/forms-json-keys';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { ButtonComponent } from '../../../../../../components/kit/button/button.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-form-msse-table',
    templateUrl: './form-msse-table.component.html',
    styleUrls: ['../form-base-table/form-base-table.scss'],
    imports: [
        TableComponent,
        PrimeTemplate,
        ButtonComponent,
        TranslatePipe,
    ],
})
export class FormMsseTableComponent extends FormBaseTableComponent {

    constructor() {
        super();
        this.generateColumns(msseKeys);
    }
}
